/* eslint-disable react/no-array-index-key */

import { memo } from 'react';
import { MenuItemElementViewModelDiscriminator, type ProductListMenuItemViewModel } from 'autogen/swagger/all';
import Menu from 'components/generic/menu';
import ListItem from 'components/List/components/ListItem/ListItem';
import CategorySideSubMenu from './CategorySideSubMenu';

export function ItemRenderer({ model }: { model: ProductListMenuItemViewModel }) {
    return MenuItemElementViewModelDiscriminator(
        model.itemElement,
        ({ text, cssClass }) => <ListItem className={cssClass}>{text}</ListItem>,
        ({ text, link: action }) => <ListItem.Action action={action}>{text}</ListItem.Action>,
        () => null
    );
}

const MenuItemsRenderer = ({ menuItems }: { menuItems: ProductListMenuItemViewModel[] }) => (
    <>
        {menuItems.map((item, index) => {
            if (item.children.length) {
                return <CategorySideSubMenu key={index} model={item} />;
            }

            return <ItemRenderer key={index} model={item} />;
        })}
    </>
);

export default memo(MenuItemsRenderer);
